import { render, staticRenderFns } from "./StockReceive.vue?vue&type=template&id=1ad9c6d2&scoped=true&"
import script from "./StockReceive.vue?vue&type=script&lang=js&"
export * from "./StockReceive.vue?vue&type=script&lang=js&"
import style0 from "./StockReceive.vue?vue&type=style&index=0&id=1ad9c6d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad9c6d2",
  null
  
)

export default component.exports